import React, {forwardRef} from 'react'

import Input from '../Input'
import {IInputProps} from '../Input/Input'

interface IFieldCardMaskInputProps extends IInputProps {}

const FieldCardMaskInput = forwardRef<HTMLInputElement, IFieldCardMaskInputProps>((props, ref) => {
	const {onChange} = props

	const onChangeMasked = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target?.value
		const cardValue = value.replace(/\D/g, '').match(/(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/) || []
		const newValue = !cardValue[2]
			? cardValue[1]
			: `${cardValue[1]} ${cardValue[2]}${`${cardValue[3] ? ` ${cardValue[3]}` : ''}`}${`${
					cardValue[4] ? ` ${cardValue[4]}` : ''
			  }`}`

		e.target.value = newValue
		onChange && onChange(e)
	}

	return <Input {...props} onChange={onChangeMasked} ref={ref} />
})

FieldCardMaskInput.displayName = 'InputCardMask'

export default FieldCardMaskInput
